@import "../../../node_modules/slick-carousel/slick/slick.min.js";

var $ = require('jquery');
require('slick-carousel');

$('.slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 770,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.slider--home').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  fade: false,
  adaptiveHeight: true,
  responsive: [
    { breakpoint: 1025,
      settings: {
        arrows: false
      }
    }
  ]
});

$('.text-slider--terratrac').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  fade: true,
  dotsClass: 'terratrac-dots'
});




// https://stackoverflow.com/a/4541963
var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();


function repositionDots() {
  // Home Slider Dot Positionierung
  if ($('.slider--home').length > 0 && window.outerWidth < 1025) {
    var items = $(".slider--home__item__background--mobile")
    var firstImg = $(items[0]).children("img");
    var imgHeight = firstImg[0].clientHeight;

    $('.slick-dots').css({top: imgHeight + 10})
  }
}

$(window).resize(function () {
  waitForFinalEvent(function(){
    repositionDots();
  }, 100, "dotsRecalculation");
});


repositionDots();